import { CmsApplianceDetailsSteppedMultiPlanBenefitsPanel } from '../../models/appliance-details-stepped-multi-plan/cms-appliance-details-stepped-multi-plan-benefits-panel.interface';

export const mockCmsApplianceDetailsSteppedMultiPlanBenefitsPanel: CmsApplianceDetailsSteppedMultiPlanBenefitsPanel =
  {
    benefits: {
      item0: {
        body: 'Benefit 1',
        icon: {
          name: 'shield-check',
        },
      },
      item1: {
        body: 'Benefit 2',
        icon: {
          name: 'dog',
        },
      },
      item2: {
        body: '<strong>Benefit 3</strong>',
        icon: {
          name: 'horse',
        },
      },
    },
  };
